import { Box, Stack, Typography } from "@mui/material";

type Props = {
  company_name: string;
  product_name: string;
};

export const ProductTitleBlock = ({ company_name, product_name }: Props) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" gap="16px">
        <Typography variant="h4" color="custom.textDarkBlue">
          {product_name}
        </Typography>
        <Box
          sx={{
            minWidth: "8px",
            minHeight: "8px",
            backgroundColor: "#4C545B",
            borderRadius: "50%",
          }}
        />
        <Typography variant="h4" color="#797F84">
          {company_name}
        </Typography>
      </Stack>
    </Stack>
  );
};
